import { useCallback } from 'react';

/**
 * Shared hook for bookmark click handling used by both BrochureSidebar and
 * MobileBrochureSidebar. Encapsulates the common pattern of reporting the
 * analytics event and jumping to the bookmarked page.
 *
 * @param {Object}   options
 * @param {Function} options.onJumpToPage         - callback to scroll PDF to a page
 * @param {Function} options.reportBookmarkClick  - analytics tracker (optional)
 * @param {Function} options.afterNavigate        - optional callback invoked after jump (e.g. close sheet)
 * @returns {Function} handleBookmarkClick(bookmark)
 */
const useBookmarkNavigation = ({
  onJumpToPage,
  reportBookmarkClick,
  afterNavigate,
} = {}) => {
  const handleBookmarkClick = useCallback(
    (bookmark) => {
      if (reportBookmarkClick) reportBookmarkClick(bookmark);
      if (onJumpToPage) onJumpToPage(bookmark.page);
      if (afterNavigate) afterNavigate();
    },
    [onJumpToPage, reportBookmarkClick, afterNavigate],
  );

  return handleBookmarkClick;
};

export default useBookmarkNavigation;
